export default precision => value =>
  Math.round(value * Math.pow(10, precision || 0)) /
  Math.pow(10, precision || 0);



// WEBPACK FOOTER //
// ./utils/round.js